class NewsDataService {
  constructor() {
    this.apiKey = 'pub_74322d7c525a8100aa962a0895c98604c24a5';
    this.baseUrl = 'https://newsdata.io/api/1';
    this.proxyUrl = '/api/newsdata';
    this.serverUrl = 'http://localhost:3001';
  }

  init(apiKey = null) {
    // Если передан новый ключ, используем его
    if (apiKey) {
      this.apiKey = apiKey;
    }
    
    // Получаем URL сервера из NewsService, если он был определен
    try {
      const NewsService = require('./NewsService').default;
      if (NewsService.serverUrl) {
        this.serverUrl = NewsService.serverUrl;
      }
    } catch (e) {
      console.log('Не удалось получить URL сервера из NewsService');
    }
  }

  async getNews(keywords, language, hoursAgo) {
    if (!this.apiKey) {
      throw new Error('NewsData.io API Key не установлен');
    }

    try {
      console.log(`Получение новостей из NewsData.io для ключевых слов: ${keywords.join(', ')}`);
      
      // Формируем параметры запроса
      // NewsData.io использует 'page_size' вместо 'size'
      const params = {
        apiKey: this.apiKey, // Используем apiKey в запросе к прокси
        language: this.mapLanguage(language),
        q: keywords.join(' OR ')
        // Удаляем параметр size, так как он вызывает ошибку
      };
      
      // Полный URL для запроса
      const url = `${this.serverUrl}${this.proxyUrl}`;
      console.log(`Отправка запроса к NewsData.io через прокси: ${url}`);
      console.log('Параметры запроса:', params);
      
      // Добавляем таймаут для запроса
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 15000); // 15 секунд таймаут
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId); // Очищаем таймаут
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Ошибка ответа от сервера:', errorText);
        throw new Error(`Ошибка API: ${response.status} ${response.statusText} - ${errorText}`);
      }
      
      const data = await response.json();
      console.log('Получен ответ от NewsData.io API:', data.status);
      
      if (!data.results || !Array.isArray(data.results)) {
        console.warn('NewsData.io вернул неожиданный формат данных:', data);
        return [];
      }
      
      // Преобразуем данные в единый формат
      const formattedResults = data.results.map(item => ({
        title: item.title,
        description: item.description || item.content || '',
        url: item.link,
        image: item.image_url || null,
        publishedAt: item.pubDate,
        source: item.source_id || 'NewsData.io',
        apiSource: 'newsdata'
      }));
      
      console.log(`Получено ${formattedResults.length} новостей из NewsData.io`);
      return formattedResults;
    } catch (error) {
      console.error('Ошибка при получении новостей из NewsData.io:', error);
      
      // Пробуем прямой запрос как запасной вариант
      try {
        console.log('Пробуем прямой запрос к NewsData.io API...');
        return await this.getNewsDirect(keywords, language, hoursAgo);
      } catch (directError) {
        console.error('Ошибка при прямом запросе к NewsData.io API:', directError);
        return [];
      }
    }
  }
  
  // Метод для прямого запроса к NewsData.io API (может не работать из-за CORS)
  async getNewsDirect(keywords, language, hoursAgo) {
    if (!this.apiKey) {
      throw new Error('NewsData.io API Key не установлен');
    }
    
    try {
      console.log(`Прямой запрос к NewsData.io API для ключевых слов: ${keywords.join(', ')}`);
      
      // Формируем параметры запроса без параметра size
      const params = new URLSearchParams({
        apikey: this.apiKey, // NewsData.io использует 'apikey', а не 'apiKey'
        language: this.mapLanguage(language),
        q: keywords.join(' OR ')
        // Удаляем параметр size, так как он вызывает ошибку
      });
      
      const url = `${this.baseUrl}/news?${params.toString()}`;
      console.log(`Прямой запрос к NewsData.io API: ${url}`);
      
      // Добавляем таймаут для запроса
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 15000); // 15 секунд таймаут
      
      const response = await fetch(url, { signal: controller.signal });
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Ошибка API: ${response.status} ${response.statusText} - ${errorText}`);
      }
      
      const data = await response.json();
      
      if (!data.results || !Array.isArray(data.results)) {
        console.warn('NewsData.io вернул неожиданный формат данных:', data);
        return [];
      }
      
      // Преобразуем данные в единый формат
      const formattedResults = data.results.map(item => ({
        title: item.title,
        description: item.description || item.content || '',
        url: item.link,
        image: item.image_url || null,
        publishedAt: item.pubDate,
        source: item.source_id || 'NewsData.io',
        apiSource: 'newsdata'
      }));
      
      console.log(`Получено ${formattedResults.length} новостей из прямого запроса к NewsData.io API`);
      return formattedResults;
    } catch (error) {
      console.error('Ошибка при прямом запросе к NewsData.io API:', error);
      return [];
    }
  }
  
  // Преобразование кода языка в формат, понятный для NewsData.io
  mapLanguage(language) {
    const languageMap = {
      'ru': 'ru',
      'en': 'en',
      'de': 'de',
      'fr': 'fr',
      'es': 'es',
      'it': 'it',
      'pt': 'pt',
      'nl': 'nl',
      'ar': 'ar',
      'zh': 'zh'
    };
    
    return languageMap[language] || 'en';
  }
}

export default new NewsDataService();

